export const PARAMS_NAME = {
    ip: 'IP',
    initialBid: 'Initial Bid',
    feedFactor: 'Feed Factor',
    hourFactor: 'Hour Factor',
    fiveMinFactor: 'Five Min Factor',
    quickFactor: 'Quick Factor',
    bidFactor: 'Bid Factor',
    countryHourFactor: 'Country Hour Factor',
    minBid: 'Min. Bid',
    maxBid: 'Max. Bid',
    bid: 'Final Bid'
};



// WEBPACK FOOTER //
// ./src/scenes/AdkCalculus/config.js